<div class="nosub-card flex-1 d-flex fd-col jc-between ai-stretch">
  <!-- <div class="d-flex jc-end ai-end">
    <button class="close-button" mat-icon-button (click)="tileInstance.hidden=true">
      <mat-icon>close</mat-icon>
    </button>
  </div> -->

  <div class="text-container flex-1 d-flex fd-col jc-center ai-center">
    <!-- <img src="assets/private/shapes.svg" class="shapes"> -->

    <span class="title">This tile requires a subscription that you do not have.</span>
    <div>
      <span class="data-source">{{ dataSource | titlecase }} </span>
      <span class="feature highlight blue">{{ feature }}</span>
    </div>
    <a class="link" routerLink="/private/my-account/subscription">My Subscriptions</a>
  </div>
</div>
